import './assets/sass/app.scss';
import { ConfigProvider } from 'antd';
import GlobalLoading from './components/GlobalLoading/index';
import { GlobalContextProvider } from './context/GlobalContext';
import { Routes } from './routes';
import { useAntdLocale } from './hooks/use-antd-locale.hook';

export const App = () => {
  const { locale } = useAntdLocale();
  return (
    <GlobalContextProvider>
      <ConfigProvider locale={{locale}}>
      <GlobalLoading />
      <Routes />
      </ConfigProvider>
    </GlobalContextProvider>
  );
};
